<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
@media (min-width: 575px) {
  .label_w6_ {
    .bold_lable_ {
      position: relative;
    }
    .ant-form-item-label {
      width: 250px;
      white-space: initial;
    }
  }
}
.table_item {
  display: flex;
  align-items: center;
  min-height: 40px;
  color: black;
  border-bottom:1px solid lightgray;
}
.l_span{
  font-size: 12px;
    font-weight:400;
    text-align: left;
    display: block;
}
// 手机端报价器样式
.mobile_ {
  .blue_checkbox_ {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
  .label_w1_ {
    .ant-form-item-label {
      width: 90px;
      padding: 0;
    }
  }
  .bold_lable_ {
    font-weight: bold;
    padding-right: 10px;
    text-align: center;
    align-items: center;
    .ant-form-item-label {
      font-weight: bold;
    }
  }
  .label_w6_ {
    .ant-form-item-label {
      width: 180px;
      white-space: initial;
    }
  }
  .label_w2_ {
    .ant-form-item-label {
      width: 180px;
      padding: 0;
    }
  }
  .label_w3_ {
    .ant-form-item-label {
      width: 172px;
      padding: 0;
      label {
        font-size: 12px;
      }
    }
  }
  .ant-form-item {
    align-items: center;
    margin-bottom: 0px;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
};
</script>